<script lang="ts" setup>import { ref as _ref, computed as _computed } from 'vue';

import blobSvg from '@consumer/assets/icons/new/blob.svg'
import v6MerchantIcon from '@consumer/assets/icons/v6/merchant.svg?svgicon'

withDefaults(defineProps<{ iconUrls: (string | undefined)[] }>(), {  })

const FIRST_OFFSET = 10
const OVERFLOW_WIDTH = 40
const LOGO_INCREMENT = 25

const failedUrls = _ref(new Set<string>())

const logosToShow = _computed(() => __props.iconUrls.length > 6 ? 5 : 6)
const overflow = _computed(() => Math.max(0, __props.iconUrls.length - logosToShow.value))

const logos = _computed(() =>
  __props.iconUrls.slice(0, logosToShow.value).map((url, index) => ({
    url,
    right: FIRST_OFFSET + (overflow.value ? OVERFLOW_WIDTH : 0) + index * LOGO_INCREMENT,
  })),
)

function renders (url?: string) {
  return !!url && !failedUrls.value.has(url)
}
</script>

<template>
  <template v-if="iconUrls.length === 1">
    <img
      v-if="renders(iconUrls[0])"
      class="giftly-v3--business-image object-cover absolute top-2 right-2 border-white rounded-full"
      :src="iconUrls[0]"
      loading="lazy"
      alt=""
      @error="failedUrls.add(iconUrls[0]!)"
    >

    <span
      v-else
      class="giftly-v3--business-image absolute top-2 right-2 border-white rounded-full bg-white
        text-v2-tertiary flex items-center justify-center"
    >
      <GIcon :svg="v6MerchantIcon" size="52em"/>
    </span>
  </template>

  <template v-else-if="iconUrls.length">
    <template v-if="overflow">
      <img class="giftly-image-v3__bubbles" :src="blobSvg" alt="">

      <div class="giftly-image-v3__bubble" :style="{ right: `${FIRST_OFFSET}em` }">
        <span class="giftly-image-v3__bubble__text">+{{ overflow }}</span>
      </div>
    </template>

    <div
      v-for="(logo, index) in logos"
      :key="index"
      class="giftly-image-v3__bubble text-v2-tertiary"
      :style="{ right: `${logo.right}em` }"
    >
      <img
        v-if="renders(logo.url)"
        class="giftly-v3--business-image"
        :src="logo.url"
        loading="lazy"
        alt=""
        @error="failedUrls.add(logo.url!)"
      >
      <GIcon v-else :svg="v6MerchantIcon" size="26em"/>
    </div>
  </template>
</template>
